import DasboardCharts from "./views/_partials/dasboardCharts";

const DemographicsMonitor = () => {
  return (
    <div className="section-wrapper section-wrapper-graphs">
      <div className="dash-section ">
        <div className="prompt-tabs w-tabs">
          <DasboardCharts></DasboardCharts>
        </div>
      </div>
    </div>
  );
};

export default DemographicsMonitor;
